import { combineReducers, createAsyncThunk } from '@reduxjs/toolkit';

import getProducts from './get_products';
import getAllProducts from './get_all_products';
import getProduct from './get_product';
import patchProduct from './patch_product';
import getProductsForPromotion from './get_products_for_promotion';
import getProductsForReservation from './get_products_for_reservation';
import getProductsForDocument from './get_products_for_document';
import getLanguages from './get_languages';
import getConstants from './get_constants';
import createProduct from './create_product';
import updateProduct from './update_product';
import getProductTranslations from './get_product_translations';
import updateProductTranslations from './update_product_translations';
import getProducers from './get_producers';
import getAllProducers from './get_all_producers';
import getProducer from './get_producer';
import createProducer from './create_producer';
import updateProducer from './update_producer';
import deleteProducer from './delete_producer';
import getAllHeatingPrograms from './get_all_heating_programs';
import updateProductEans from './update_product_eans';
import getPriceListProducts from './get_price_list_products';
import getProductsFromProductAvailabilityForDocument from './get_products_from_product_availability_for_document';
import { webClientFileDownload } from '../../core/web_client';
import { exportFile, extractErrorDataFromFile, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_PATH } from '../../core/constants';

export const getProductLabel = createAsyncThunk(
    'product/getProductLabel',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClientFileDownload.get(`${ PRODUCTS_PATH }/${ data.id }/label?productBatchId=${ data.productBatchId }`);
            const fileName = response.headers['content-disposition']?.split('filename=')[1]?.replaceAll("\"", "");
            exportFile(extractResponseData(response), fileName ? fileName : data.title + '.pdf');
            return fulfillWithValue();
        } catch (error) {
            const response = await extractErrorDataFromFile(extractResponseData(error?.response));
            return rejectWithValue(response);
        }
    }
);

export default combineReducers({
    getProducts, getAllProducts, getProduct, patchProduct,
    getProductsForReservation, getProductsForPromotion, getProductsForDocument,
    getLanguages, getConstants, createProduct, updateProduct,
    getProductTranslations, updateProductTranslations,
    getProducers, getAllProducers, getProducer, createProducer, updateProducer, deleteProducer,
    getAllHeatingPrograms, updateProductEans, getPriceListProducts, getProductsFromProductAvailabilityForDocument
});
